import { render, staticRenderFns } from "./ThanasCreateEdit.vue?vue&type=template&id=30426a10&"
import script from "./ThanasCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ThanasCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports